<template>
  <div class="page-container">
    <div class="page-header">
      <h2 v-if="title">{{ title }}</h2>

      <slot name="header"></slot>
    </div>

    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageContainer',
  props: {
    title: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 1rem 1.875rem;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  h2 {
    margin: 0;
    font-size: 2rem;
    font-weight: 700;
    color: #202224;
  }

  .page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .page-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}
</style>
